import { render, staticRenderFns } from "./TimeSince.vue?vue&type=template&id=7ccd8674&scoped=true&"
import script from "./TimeSince.vue?vue&type=script&lang=js&"
export * from "./TimeSince.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccd8674",
  null
  
)

export default component.exports